import type { BaseTranslation } from "../i18n-types";

const chat: BaseTranslation = {
    intro: "Here is your chat history:",
    adventurers: "Users",
    onlineUsers: "Online user",
    getCloserTitle: "Get closer to someone",
    getCloserDesc:
        "When you approach someone in the virtual space, a conversation bubble automatically opens, allowing you to talk directly as if you were face-to-face.",
    noMessage: "No message sent yet!",
    beFirst: "Be the first and send a message",
    enter: "Enter your message...",
    menu: {
        visitCard: "Visit card",
        addFriend: "Add friend",
    },
    loader: "Loading...",
    typing: "is typing...",
    users: "Users",
    chat: "Chat",
    userList: {
        disconnected: "Not connected to the world",
        isHere: "Is on this map",
        inAnotherMap: "In another map",
        in: "In ",
        teleport: "Teleport",
        search: "Just look it up!",
        walkTo: "Walk to",
        teleporting: "Teleporting ...",
        businessCard: "Business Card",
        sendMessage: "Send Message",
    },
    accept: "Accept",
    decline: "Decline",
    join: "Join",
    connecting: "Connecting to server ...",
    waitingInit: "Waiting for server initialization ...",
    waitingData: "Waiting user data ...",
    searchUser: "Search for user, map, etc ...",
    searchChat: "Search for channel, message, etc ...",
    people: "People",
    rooms: "Rooms",
    addNew: "Add new : ",
    invitations: "Invitations",
    suggestedRooms: "Suggested rooms",
    availableRooms: "Available rooms",
    proximity: "Proximity Chat",
    role: {
        adminShort: "Admin",
        admin: "Administrator",
        member: "Member",
        visitor: "Visitor",
    },
    status: {
        online: "Online",
        away: "Away",
        unavailable: "Unavailable",
        back_in_a_moment: "Back in a moment",
        do_not_disturb: "Do not disturb",
        busy: "Busy",
        meeting: "In a meeting",
        megaphone: "Using the megaphone",
    },
    logIn: "Log in",
    signIn: "Register or log in to enjoy all the features of the chat !",
    invite: "Invite",
    roomEmpty: "This room is empty, invite a colleague or friend to join you!",
    userOnline: "user online",
    usersOnline: "users online",
    open: "Open",
    me: "Me",
    you: "You",
    ban: {
        title: "Ban",
        content: "Ban user {userName} from the running world. This can be cancelled from the administration.",
        ban: "Ban this user",
    },
    loading: "Loading",
    loadingUsers: "Loading the users ...",
    load: "Load",
    rankUp: "Promote",
    rankDown: "Retrograde",
    reinit: "Re initialize",
    enterText: "Enter a message ...",
    timeLine: {
        title: "Your Timeline",
        open: "Open your time line history!",
        description: "Messages and events history",
        incoming: "{userName} joined the discussion",
        outcoming: "{userName} has left the discussion",
        youLeft: "You left the discussion",
    },
    form: {
        placeholder: "Enter your message...",
        typing: " typing...",
        application: {
            klaxoon: {
                title: "Klaxoon",
                description: "Send embedded klaxoon in the chat!",
            },
            youtube: {
                title: "YouTube",
                description: "Send embedded youtube video in the chat!",
            },
            googleDocs: {
                title: "Google Docs",
                description: "Send embedded google docs in the chat!",
            },
            googleSlides: {
                title: "Google Slides",
                description: "Send embedded google slides in the chat!",
            },
            googleSheets: {
                title: "Google Sheets",
                description: "Send embedded google sheets in the chat!",
            },
            eraser: {
                title: "Eraser",
                description: "Send embedded eraser in the chat!",
            },
            googleDrive: {
                title: "Google Drive",
                description: "Send a file from google drive in the chat!",
            },
            excalidraw: {
                title: "Excalidraw",
                description:
                    "Send an source virtual hand-drawn style whiteboard. Collaborative and end-to-end encrypted.",
            },
            cards: {
                title: "Cards",
                description: "Send a card in the chat!",
            },
            weblink: {
                error: "Please enter a valid URL",
            },
        },
    },
    notification: {
        discussion: "wants to discuss with you",
        message: "sends a message",
        forum: "on the forum",
    },
    see: "See",
    show: "Show",
    less: "less",
    more: "more",
    sendBack: "Send back",
    delete: "Delete",
    messageDeleted: "Message deleted",
    emoji: {
        icon: "Icon to open or close emoji selected popup",
        search: "Search emojis...",
        categories: {
            recents: "Recent Emojis",
            smileys: "Smileys & Emotion",
            people: "People & Body",
            animals: "Animals & Nature",
            food: "Food & Drink",
            activities: "Activities",
            travel: "Travel & Places",
            objects: "Objects",
            symbols: "Symbols",
            flags: "Flags",
            custom: "Custom",
        },
        notFound: "No emojis found",
    },
    said: "said :",
    reply: "Reply",
    react: "React",
    copy: "Copy",
    copied: "Copied!",
    file: {
        fileContentNoEmbed: "Content unavailable for viewing. Please download it",
        download: "download",
        openCoWebsite: "Open in co-website",
        copy: "copy the link",
        tooBig: "{fileName} is too big {maxFileSize}.",
        notLogged: "You need to be logged in to upload a file.",
    },
    needRefresh: "Your connection has expired, you need to refresh the page to reconnect to the chat.",
    refresh: "Refresh",
    upgrade: "Upgrade",
    upgradeToSeeMore: "Upgrade to see more messages",
    disabled: "This feature is disabled.",
    disabledByAdmin: "This feature is disabled by the administrator.",
    anAdmin: "an administrator",
    messageDeletedByYou: "You deleted this message",
    messageEdited: "Modified",
    messageEditedError: "Unable to edit message. Try again.",
    waiting: "Waiting",
    nothingToDisplay: "Nothing to display",
    showMore: "Show {number} more",
    showLess: "Show less",
    addRoomToFolderError: "Impossible to add the room to the folder",
    createRoom: {
        title: "Create new room",
        name: "Name",
        visibility: {
            label: "Visibility",
            private: "Private",
            privateDescription: "Only invited guests will be able to find and join the room.",
            public: "Public",
            publicDescription: "Anyone can find and join the room.",
            restricted: "Folder member",
            restrictedDescription: "Visible only to members of the folder",
        },
        e2eEncryption: {
            label: "Activate end to end encryption",
            description: "You won't be able to deactivate it later.",
        },
        suggested: "Suggested room",
        suggestedDescription: "This room will be suggested to users who in the same space.",
        users: "Users",
        historyVisibility: {
            label: "Who can read history ?",
            world_readable: "Anyone",
            joined: "Members only (since they joined)",
            invited: "Members only (since they were invited)",
        },
        buttons: {
            edit: "Edit",
            create: "Create",
            cancel: "Cancel",
        },
        error: "Error on room creation",
        loadingCreation: "Room creation in progress",
        creationSuccessNotification: "Room created",
    },
    createFolder: {
        title: "Create new folder",
        name: "Name",
        visibility: {
            label: "Visibility",
            private: "Private",
            privateDescription: "Only invited guests will be able to find and join the room.",
            public: "Public",
            publicDescription: "Anyone can find and join the room.",
            restricted: "Folder member",
            restrictedDescription: "Visible only to members of the folder",
        },
        description: {
            label: "Description",
            placeholder: "Description",
        },
        e2eEncryption: {
            label: "Activate end to end encryption",
            description: "You won't be able to deactivate it later.",
        },
        users: "Users",
        historyVisibility: {
            label: "Who can read history ?",
            world_readable: "Anyone",
            joined: "Members only (since they joined)",
            invited: "Members only (since they were invited)",
        },
        buttons: {
            create: "Create",
            cancel: "Cancel",
        },
        error: "Error on room creation",
        loadingCreation: "Room creation in progress",
        creationSuccessNotification: "Room created",
    },
    manageRoomUsers: {
        roomOption: "Participants",
        error: "Unable send invitations",
        title: "Manage participants",
        invitations: "Invitations",
        participants: "Participants",
        join: "Joined",
        invite: "Invited",
        ban: "Banned",
        kick: "Kicked",
        leave: "Leaved",
        roomID: "Room ID : {roomId}",
        membership: "Membership",
        permissionLevel: "Roles",
        actions: "Actions",
        buttons: {
            sendInvitations: "Send invitations",
            cancel: "Cancel",
            ban: "Ban",
            kick: "Kick",
            unban: "Unban",
            invite: "Invite",
        },
        roles: {
            USER: "User",
            ADMIN: "Admin",
            MODERATOR: "Moderator",
        },
        sendInvitationsSuccessNotification: "Invitations sent successfully",
    },
    roomMenu: {
        leaveRoom: {
            label: "Leave room",
            notification: "You have left the room",
        },
        muteRoom: "Mute Room",
        unmuteRoom: "Unmute Room",
    },
    folderMenu: {
        leaveFolder: {
            label: "Leave Folder",
            notification: "You have left the folder",
        },
    },
    e2ee: {
        configure: "Configure",
        encryptionNotConfigured: "Encryption not configured",
        createRecoveryKey: {
            title: "Chat recovery key creation",
            description:
                "In order use end to end encryption in the chat, you need to create a recovery key. Please enter your recovery passphrase below, a recovery key will be created.",
            privateKeyDescription:
                "This is your recovery key, save it somewhere to retrieve encrypted discussions after logged out.",
            error: "Something went wrong on generateRecoveryKeyFromPassphrase",
            buttons: {
                generate: "Generate",
                continue: "Continue",
                cancel: "Cancel",
            },
        },
        interactiveAuth: {
            title: "End-to-end encryption for chat",
            description:
                "For security reasons, a key must be uploaded to our server to verify your identity. By confirming your identity, you will store the key, which allows you to read encrypted messages from WA and other clients.",
            instruction: "Make sure to complete the SSO connection before clicking the Finish button.",
            buttons: {
                cancel: "Cancel",
                continueSSO: "Continue with SSO",
                finish: "Finish",
            },
        },
        accessSecretStorage: {
            title: "Chat session verification",
            description:
                "In order to verify your session and retrieve encrypted messages, you need to enter your recovery key or passphrase.",
            passphrase: "Passphrase",
            recoveryKey: "Recovery key",
            placeholder: "Enter your",
            buttons: {
                cancel: "Cancel",
                usePassphrase: "Use recovery passphrase instead",
                useRecoveryKey: "Use recovery key instead",
                confirm: "Confirm",
            },
        },
    },
    connectionError: "Chat not available",
    requiresLoginForChatModal: {
        title: "Log in to unlock the chat !",
        content_1: "To fully enjoy this chat feature, you need to be logged into your account.",
        content_2: "Logging in gives you access to all options and allows you to continue without interruption.",
        content_3: " Please log in to proceed with the experience.",
    },
    verificationEmojiDialog: {
        confirmation: "They match",
        mismatch: "They don't match",
        title: "Verify device",
        titleVerifyThisDevice: "Verify your device",
        titleVerifyOtherDevice: "Verify a other device",
        description: "Confirm that the emojis below are displayed on both devices and in the same order:",
        waitForOtherDevice: "Waiting for the other device ...",
        waitOtherDeviceConfirmation: "waiting for other device confirmation ...",
        understood: "Understood",
        error: "Error during the validation process…",
    },
    chooseDeviceVerificationMethodModal: {
        title: "Verify device",
        description: "Choose the verification method",
        withOtherDevice: "Verify with another device",
        withPassphrase: "Verify with security passphrase",
    },
    askStartVerificationModal: {
        title: "Verification required",
        accept: "Verify the session",
        ignore: "Ignore",
        from: "from",
    },
    requiresLoginForChat: "Sign in to access the chat messages",
    emojis: {
        Dog: "Dog",
        Cat: "Cat",
        Lion: "Lion",
        Horse: "Horse",
        Unicorn: "Unicorn",
        Pig: "Pig",
        Elephant: "Elephant",
        Rabbit: "Rabbit",
        Panda: "Panda",
        Rooster: "Rooster",
        Penguin: "Penguin",
        Turtle: "Turtle",
        Fish: "Fish",
        Octopus: "Octopus",
        Butterfly: "Butterfly",
        Flower: "Flower",
        Tree: "Tree",
        Cactus: "Cactus",
        Mushroom: "Mushroom",
        Globe: "Globe",
        Moon: "Moon",
        Cloud: "Cloud",
        Fire: "Fire",
        Banana: "Banana",
        Apple: "Apple",
        Strawberry: "Strawberry",
        Corn: "Corn",
        Pizza: "Pizza",
        Cake: "Cake",
        Heart: "Heart",
        Smiley: "Smiley",
        Robot: "Robot",
        Hat: "Hat",
        Glasses: "Glasses",
        Spanner: "Spanner",
        Santa: "Santa",
        "Thumbs Up": "Thumbs Up",
        Umbrella: "Umbrella",
        Hourglass: "Hourglass",
        Clock: "Clock",
        Gift: "Gift",
        "Light Bulb": "Light Bulb",
        Book: "Book",
        Pencil: "Pencil",
        Paperclip: "Paperclip",
        Scissors: "Scissors",
        Lock: "Lock",
        Key: "Key",
        Hammer: "Hammer",
        Telephone: "Telephone",
        Flag: "Flag",
        Train: "Train",
        Bicycle: "Bicycle",
        Aeroplane: "Aeroplane",
        Rocket: "Rocket",
        Trophy: "Trophy",
        Ball: "Ball",
        Guitar: "Guitar",
        Trumpet: "Trumpet",
        Bell: "Bell",
        Anchor: "Anchor",
        Headphones: "Headphones",
        Folder: "Folder",
        Pin: "Pin",
        unknownLabel: "Unknown Label",
    },
    fileAttachment: {
        title: "File attachment",
        description: "Upload and share a file",
        featureComingSoon: "Coming soon!",
    },
    loginTokenError: "An error occurred. Please try to reconnect",
    reconnect: "Reconnect",
    failedToJoinRoom: "Failed to join room",
    failedToLeaveRoom: "Failed to leave room",
    refreshChat: "Refresh Chat",
    dismiss: "Dismiss",
    whoops: "Whoops ! something went wrong",
    failedToOpenRoom: "Failed to open room : {roomId}",
    refreshChatError: "Failed to refresh chat",
};

export default chat;
